<template>
  <a
    href="#"
    class="nav-link py-0 text-muted"
    @click.prevent="toggleStar"
    @mouseover="showTooltip"
    @mouseleave="hideTooltip"
    data-bs-toggle="tooltip"
    data-bs-placement="top"
    :title="$t('Add to favorites')"
  >
    <i
      :class="{
        'far': !isStarred,
        'fas text-warning': isStarred,
        'fa-star': true,
      }"
    ></i>
  </a>
</template>

<script>
export default {
  props: ['lecture'],
  computed:{
    starred() {
      return this.$store.state.starred
    },
    isStarred() {
      return _.some(this.starred, { lecture_id: this.lecture.id })
    },
  },
  methods: {
    showTooltip(event) {
      bootstrap.Tooltip.getOrCreateInstance(event.target).show()
    },
    hideTooltip(event) {
      bootstrap.Tooltip.getOrCreateInstance(event.target).hide()
    },

    async toggleStar() {
      try {
        const result = await this.$api.starLecture(this.lecture.id)
        this.$store.commit('starLecture', result.data)
      } catch (error) {
        if (error.response && error.response.status === 401) {
          iziToast.info({
            title: this.$t('Log in now'),
          })
        } else if (error.response && error.response.status === 419) {
          iziToast.info({
            title: this.$t('Log in'),
            message: this.$t('Session expired'),
          })
        } else {
          console.error(error)
          iziToast.error({
            title: 'Error',
            message: this.$t('Something went wrong'),
            position: 'bottomLeft',
          })
        }
      }
    },
  },
}
</script>
